interface TeamMemberInfo {
  jobTitle: string;
  speciality: string;
  teamName: string;
}

const specialityOptions = [
  {
    value: '100',
    label: 'General Surgery Service',
  },
  {
    value: '101',
    label: 'Urology Service',
  },
  {
    value: '102',
    label: 'Transplant Surgery Service',
  },
  {
    value: '103',
    label: 'Breast Surgery Service',
  },
  {
    value: '104',
    label: 'Colorectal Surgery Service',
  },
  {
    value: '105',
    label: 'Hepatobiliary and Pancreatic Surgery Service',
  },
  {
    value: '106',
    label: 'Upper Gastrointestinal Surgery Service',
  },
  {
    value: '107',
    label: 'Vascular Surgery Service',
  },
  {
    value: '108',
    label: 'Spinal Surgery Service',
  },
  {
    value: '109',
    label: 'Bariatric Surgery Service',
  },
  {
    value: '110',
    label: 'Trauma and Orthopaedic Service',
  },
  {
    value: '111',
    label: 'Orthopaedic Service',
  },
  {
    value: '113',
    label: 'Endocrine Surgery Service',
  },
  {
    value: '115',
    label: 'Trauma Surgery Service',
  },
  {
    value: '120',
    label: 'Ear Nose and Throat Service',
  },
  {
    value: '130',
    label: 'Ophthalmology Service',
  },
  {
    value: '140',
    label: 'Oral Surgery Service',
  },
  {
    value: '141',
    label: 'Restorative Dentistry Service',
  },
  {
    value: '143',
    label: 'Orthodontic Service',
  },
  {
    value: '144',
    label: 'Maxillofacial Surgery Service',
  },
  {
    value: '145',
    label: 'Oral and Maxillofacial Surgery Service',
  },
  {
    value: '150',
    label: 'Neurosurgical Service',
  },
  {
    value: '160',
    label: 'Plastic Surgery Service',
  },
  {
    value: '161',
    label: 'Burns Care Service',
  },
  {
    value: '170',
    label: 'Cardiothoracic Surgery Service',
  },
  {
    value: '172',
    label: 'Cardiac Surgery Service',
  },
  {
    value: '173',
    label: 'Thoracic Surgery Service',
  },
  {
    value: '174',
    label: 'Cardiothoracic Transplantation Service',
  },
  {
    value: '191',
    label: 'Pain Management Service',
  },
  {
    value: '142',
    label: 'Paediatric Dentistry Service',
  },
  {
    value: '171',
    label: 'Paediatric Surgery Service',
  },
  {
    value: '211',
    label: 'Paediatric Urology Service',
  },
  {
    value: '212',
    label: 'Paediatric Transplantation Surgery Service',
  },
  {
    value: '213',
    label: 'Paediatric Gastrointestinal Surgery Service',
  },
  {
    value: '214',
    label: 'Paediatric Trauma and Orthopaedic Service',
  },
  {
    value: '215',
    label: 'Paediatric Ear Nose and Throat Service',
  },
  {
    value: '216',
    label: 'Paediatric Ophthalmology Service',
  },
  {
    value: '217',
    label: 'Paediatric Oral and Maxillofacial Surgery Service',
  },
  {
    value: '218',
    label: 'Paediatric Neurosurgery Service',
  },
  {
    value: '219',
    label: 'Paediatric Plastic Surgery Service',
  },
  {
    value: '220',
    label: 'Paediatric Burns Care Service',
  },
  {
    value: '221',
    label: 'Paediatric Cardiac Surgery Service',
  },
  {
    value: '222',
    label: 'Paediatric Thoracic Surgery Service',
  },
  {
    value: '223',
    label: 'Paediatric Epilepsy Service',
  },
  {
    value: '230',
    label: 'Paediatric Clinical Pharmacology Service',
  },
  {
    value: '240',
    label: 'Paediatric Palliative Medicine Service',
  },
  {
    value: '241',
    label: 'Paediatric Pain Management Service',
  },
  {
    value: '242',
    label: 'Paediatric Intensive Care Service',
  },
  {
    value: '250',
    label: 'Paediatric Hepatology Service',
  },
  {
    value: '251',
    label: 'Paediatric Gastroenterology Service',
  },
  {
    value: '252',
    label: 'Paediatric Endocrinology Service',
  },
  {
    value: '253',
    label: 'Paediatric Clinical Haematology Service',
  },
  {
    value: '254',
    label: 'Paediatric Audio Vestibular Medicine Service',
  },
  {
    value: '255',
    label: 'Paediatric Clinical Immunology and Allergy Service',
  },
  {
    value: '256',
    label: 'Paediatric Infectious Diseases Service',
  },
  {
    value: '257',
    label: 'Paediatric Dermatology Service',
  },
  {
    value: '258',
    label: 'Paediatric Respiratory Medicine Service',
  },
  {
    value: '259',
    label: 'Paediatric Nephrology Service',
  },
  {
    value: '260',
    label: 'Paediatric Medical Oncology Service',
  },
  {
    value: '261',
    label: 'Paediatric Inherited Metabolic Medicine Service',
  },
  {
    value: '262',
    label: 'Paediatric Rheumatology Service',
  },
  {
    value: '263',
    label: 'Paediatric Diabetes Service',
  },
  {
    value: '264',
    label: 'Paediatric Cystic Fibrosis Service',
  },
  {
    value: '270',
    label: 'Paediatric Emergency Medicine Service',
  },
  {
    value: '280',
    label: 'Paediatric Interventional Radiology Service',
  },
  {
    value: '290',
    label: 'Community Paediatric Service',
  },
  {
    value: '291',
    label: 'Paediatric Neurodisability Service',
  },
  {
    value: '321',
    label: 'Paediatric Cardiology Service',
  },
  {
    value: '421',
    label: 'Paediatric Neurology Service',
  },
  {
    value: '180',
    label: 'Emergency Medicine Service',
  },
  {
    value: '190',
    label: 'Anaesthetic Service',
  },
  {
    value: '192',
    label: 'Intensive Care Medicine Service',
  },
  {
    value: '200',
    label: 'Aviation and Space Medicine Service',
  },
  {
    value: '300',
    label: 'General Internal Medicine Service',
  },
  {
    value: '301',
    label: 'Gastroenterology Service',
  },
  {
    value: '302',
    label: 'Endocrinology Service',
  },
  {
    value: '303',
    label: 'Clinical Haematology Service',
  },
  {
    value: '304',
    label: 'Clinical Physiology Service',
  },
  {
    value: '305',
    label: 'Clinical Pharmacology Service',
  },
  {
    value: '306',
    label: 'Hepatology Service',
  },
  {
    value: '307',
    label: 'Hepatology Service',
  },
  {
    value: '308',
    label: 'Blood and Marrow Transplantation Service',
  },
  {
    value: '309',
    label: 'Haemophilia Service',
  },
  {
    value: '310',
    label: 'Audio Vestibular Medicine Service',
  },
  {
    value: '311',
    label: 'Clinical Genetics Service',
  },
  {
    value: '313',
    label: 'Clinical Immunology and Allergy Service',
  },
  {
    value: '314',
    label: 'Rehabilitation Medicine Service',
  },
  {
    value: '315',
    label: 'Palliative Medicine Service',
  },
  {
    value: '316',
    label: 'Clinical Immunology Service',
  },
  {
    value: '317',
    label: 'Allergy Service',
  },
  {
    value: '318',
    label: 'Intermediate Care Service',
  },
  {
    value: '319',
    label: 'Respite Care Service',
  },
  {
    value: '320',
    label: 'Cardiology Service',
  },
  {
    value: '322',
    label: 'Clinical Microbiology Service',
  },
  {
    value: '323',
    label: 'Spinal Injuries Service',
  },
  {
    value: '324',
    label: 'Anticoagulant Service',
  },
  {
    value: '325',
    label: 'Sport and Exercise Medicine Service',
  },
  {
    value: '326',
    label: 'Acute Internal Medicine Service',
  },
  {
    value: '327',
    label: 'Cardiac Rehabilitation Service',
  },
  {
    value: '328',
    label: 'Stroke Medicine Service',
  },
  {
    value: '329',
    label: 'Transient Ischaemic Attack Service',
  },
  {
    value: '330',
    label: 'Dermatology Service',
  },
  {
    value: '331',
    label: 'Congenital Heart Disease Service',
  },
  {
    value: '333',
    label: 'Rare Disease Service',
  },
  {
    value: '335',
    label: 'Inherited Metabolic Medicine Service',
  },
  {
    value: '340',
    label: 'Respiratory Medicine Service',
  },
  {
    value: '341',
    label: 'Respiratory Physiology Service',
  },
  {
    value: '342',
    label: 'Pulmonary Rehabilitation Service',
  },
  {
    value: '343',
    label: 'Adult Cystic Fibrosis Service',
  },
  {
    value: '344',
    label: 'Complex Specialised Rehabilitation Service',
  },
  {
    value: '345',
    label: 'Specialist Rehabilitation Service',
  },
  {
    value: '346',
    label: 'Local Specialist Rehabilitation Service',
  },
  {
    value: '347',
    label: 'Sleep Medicine Service',
  },
  {
    value: '348',
    label: 'Post-COVID-19 Syndrome Service',
  },
  {
    value: '350',
    label: 'Infectious Diseases Service',
  },
  {
    value: '352',
    label: 'Tropical Medicine Service',
  },
  {
    value: '360',
    label: 'Genitourinary Medicine Service',
  },
  {
    value: '361',
    label: 'Renal Medicine Service',
  },
  {
    value: '370',
    label: 'Medical Oncology Service',
  },
  {
    value: '371',
    label: 'Nuclear Medicine Service',
  },
  {
    value: '400',
    label: 'Neurology Service',
  },
  {
    value: '401',
    label: 'Clinical Neurophysiology Service',
  },
  {
    value: '410',
    label: 'Rheumatology Service',
  },
  {
    value: '420',
    label: 'Paediatric Service',
  },
  {
    value: '422',
    label: 'Neonatal Critical Care Service',
  },
  {
    value: '424',
    label: 'Well Baby Service',
  },
  {
    value: '430',
    label: 'Elderly Medicine Service',
  },
  {
    value: '431',
    label: 'Orthogeriatric Medicine Service',
  },
  {
    value: '450',
    label: 'Dental Medicine Service',
  },
  {
    value: '451',
    label: 'Special Care Dentistry Service',
  },
  {
    value: '460',
    label: 'Medical Ophthalmology Service',
  },
  {
    value: '461',
    label: 'Ophthalmic and Vision Science Service',
  },
  {
    value: '501',
    label: 'Obstetrics Service',
  },
  {
    value: '502',
    label: 'Gynaecology Service',
  },
  {
    value: '503',
    label: 'Gynaecological Oncology Service',
  },
  {
    value: '504',
    label: 'Community Sexual and Reproductive Health Service',
  },
  {
    value: '505',
    label: 'Fetal Medicine Service',
  },
  {
    value: '510',
    label: 'Retired but retained for historical purposes',
  },
  {
    value: '520',
    label: 'Retired but retained for historical purposes',
  },
  {
    value: '560',
    label: 'Midwifery Service',
  },
  {
    value: '610',
    label: 'Retired but retained for historical purposes',
  },
  {
    value: '620',
    label: 'Retired but retained for historical purposes',
  },
  {
    value: '656',
    label: 'Clinical Psychology Service',
  },
  {
    value: '700',
    label: 'Learning Disability Service',
  },
  {
    value: '710',
    label: 'Adult Mental Health Service',
  },
  {
    value: '711',
    label: 'Child and Adolescent Psychiatry Service',
  },
  {
    value: '712',
    label: 'Forensic Psychiatry Service',
  },
  {
    value: '713',
    label: 'Medical Psychotherapy Service',
  },
  {
    value: '715',
    label: 'Old Age Psychiatry Service',
  },
  {
    value: '720',
    label: 'Eating Disorders Service',
  },
  {
    value: '721',
    label: 'Addiction Service',
  },
  {
    value: '722',
    label: 'Liaison Psychiatry Service',
  },
  {
    value: '723',
    label: 'Psychiatric Intensive Care Service',
  },
  {
    value: '724',
    label: 'Perinatal Mental Health Service',
  },
  {
    value: '725',
    label: 'Mental Health Recovery and Rehabilitation Service',
  },
  {
    value: '726',
    label: 'Mental Health Dual Diagnosis Service',
  },
  {
    value: '727',
    label: 'Dementia Assessment Service',
  },
  {
    value: '730',
    label: 'Neuropsychiatry Service',
  },
  {
    value: '800',
    label: 'Clinical Oncology Service',
  },
  {
    value: '811',
    label: 'Interventional Radiology Service',
  },
  {
    value: '812',
    label: 'Diagnostic Imaging Service',
  },
  {
    value: '822',
    label: 'Chemical Pathology Service',
  },
  {
    value: '832',
    label: 'Retired but retained for historical purposes',
  },
  {
    value: '834',
    label: 'Medical Virology Service',
  },
  {
    value: '650',
    label: 'Physiotherapy Service',
  },
  {
    value: '651',
    label: 'Occupational Therapy Service',
  },
  {
    value: '652',
    label: 'Speech and Language Therapy Service',
  },
  {
    value: '653',
    label: 'Podiatry Service',
  },
  {
    value: '654',
    label: 'Dietetics Service',
  },
  {
    value: '655',
    label: 'Orthoptics Service',
  },
  {
    value: '657',
    label: 'Prosthetics Service',
  },
  {
    value: '658',
    label: 'Orthotics Service',
  },
  {
    value: '659',
    label: 'Dramatherapy Service',
  },
  {
    value: '660',
    label: 'Art Therapy Service',
  },
  {
    value: '661',
    label: 'Music Therapy Service',
  },
  {
    value: '662',
    label: 'Optometry Service',
  },
  {
    value: '663',
    label: 'Podiatric Surgery Service',
  },
  {
    value: '670',
    label: 'Urological Physiology Service',
  },
  {
    value: '673',
    label: 'Vascular Physiology Service',
  },
  {
    value: '675',
    label: 'Cardiac Physiology Service',
  },
  {
    value: '677',
    label: 'Gastrointestinal Physiology Service',
  },
  {
    value: '840',
    label: 'Audiology Service',
  },
  {
    value: '920',
    label: 'Diabetic Education Service',
  },
  {
    value: '990',
    label: 'Retired but retained for historical purposes',
  },
];

export { specialityOptions };
export type { TeamMemberInfo };
